import axios from '../../../../shared/axios/axios';
import * as actionTypes from './actionTypes';
import { apiOptions } from '../../../../shared/constants/apiOptions';

const getFilesControlConfigurationStart = () => {
  return {
    type: actionTypes.GET_FILES_CONTROL_CONFIGURATION,
  };
};

const getFilesControlConfigurationSuccess = (data) => {
  return {
    type: actionTypes.GET_FILES_CONTROL_CONFIGURATION_SUCCESS,
    controlConfiguration: data,
  };
};

const getFilesControlConfigurationFail = (error) => {
  return {
    type: actionTypes.GET_FILES_CONTROL_CONFIGURATION_FAIL,
    error: error,
  };
};

export const getFilesControlConfiguration = (isSendFiles) => {
  return (dispatch) => {
    dispatch(getFilesControlConfigurationStart());

    const url = `${apiOptions.apiRoot}/files/get-files-control-configuration?isSendFiles=${isSendFiles ? 'true' : 'false'}`;

    axios
      .get(url)
      .then((response) => {
        dispatch(getFilesControlConfigurationSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getFilesControlConfigurationFail(err));
      });
  };
};

const verifyFolderStructureStart = () => {
  return {
    type: actionTypes.VERIFY_FOLDER_STRUCTURE,
  };
};

const verifyFolderStructureSuccess = (data) => {
  return {
    type: actionTypes.VERIFY_FOLDER_STRUCTURE_SUCCESS,
    verifyFolderStructureResult: data,
  };
};

const verifyFolderStructureFail = (error) => {
  return {
    type: actionTypes.VERIFY_FOLDER_STRUCTURE_FAIL,
    error: error,
  };
};

export const verifyFolderStructure = (formData) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(verifyFolderStructureStart());

      const url = `${apiOptions.apiRoot}/files/verify-folder-structure`;

      axios
        .post(url, formData)
        .then((response) => {
          dispatch(verifyFolderStructureSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(verifyFolderStructureFail(err));
          reject(err);
        });
    });
  };
};
